import React, { FC } from 'react'

import InputItem from '../../../components/InputItem'
import { ITabBaseProps } from './types'

export const Impacts: FC<ITabBaseProps> = ({ formik }) => {
  return (
    <div className="mb-5 mt-5">
      <h5 className={'mt-5'}>Impacts</h5>
      <p>Please provide impacts for 1 unit of the specified resource-source.</p>
      <div className={'piece-content-inputs'}>
        <InputItem
          name="Carbon"
          description="Please provide carbon emissions in kg CO2 eq"
          type="input"
          addonTitle="kg"
          formik={formik}
          showAsterisk
          onChange={formik.handleChange}
          defaultValue={formik.values.carbon === 0 ? '0' : formik.values.carbon}
          formikName="carbon"
        />
        <InputItem
          name="Land Use"
          description="Please provide Land use in m2*year."
          type="input"
          addonTitle="m2*y"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue('landUse', val === '' ? null : val)
          }}
          formikName="landUse"
          showAsterisk={false}
          formik={formik}
          defaultValue={formik.values.landUse === 0 ? '0' : formik.values.landUse}
        />
        <InputItem
          name="Water usage"
          description="Please provide water usage in m3"
          type="input"
          addonTitle="m3"
          formik={formik}
          showAsterisk
          onChange={formik.handleChange}
          defaultValue={formik.values.waterUsage === 0 ? '0' : formik.values.waterUsage}
          formikName="waterUsage"
        />
        <InputItem
          name="Eutrophication"
          description="Please provide eutrophication in  kg PO4^3- eq"
          type="input"
          addonTitle="kg"
          formik={formik}
          showAsterisk
          onChange={formik.handleChange}
          defaultValue={formik.values.eutrophication === 0 ? '0' : formik.values.eutrophication}
          formikName="eutrophication"
        />
      </div>
      <div className="piece-content-inputs mb-5">
        <InputItem
          name="Abiotic depletion"
          description="Unit of Measure: kg Sb eq"
          type="input"
          addonTitle="kg Sb eq"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue('impacts.abioticDepletion', val === '' ? null : val)
          }}
          formikName="impacts.abioticDepletion"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.abioticDepletion === 0
              ? '0'
              : formik.values.impacts.abioticDepletion
          }
        />
        <InputItem
          name="Abiotic depletion (fossil fuels)"
          description="Unit of Measure: MJ"
          type="input"
          addonTitle="MJ"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue('impacts.abioticDepletionFossilFuels', val === '' ? null : val)
          }}
          formikName="impacts.abioticDepletionFossilFuels"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.abioticDepletionFossilFuels === 0
              ? '0'
              : formik.values.impacts.abioticDepletionFossilFuels
          }
        />
        <InputItem
          name="Acidification"
          description="Unit of Measure: mol H+ eq"
          type="input"
          addonTitle="mol H+ eq"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue('impacts.acidification', val === '' ? null : val)
          }}
          formikName="impacts.acidification"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.acidification === 0 ? '0' : formik.values.impacts.acidification
          }
        />
        <InputItem
          name="Ecotoxicity freshwater"
          description="Unit of Measure: CTUe"
          type="input"
          addonTitle="CTUe"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue('impacts.ecotoxicityFreshwater', val === '' ? null : val)
          }}
          formikName="impacts.ecotoxicityFreshwater"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.ecotoxicityFreshwater === 0
              ? '0'
              : formik.values.impacts.ecotoxicityFreshwater
          }
        />
        <InputItem
          name="Eutrophication terrestrial"
          description="Unit of Measure: mol N eq"
          type="input"
          addonTitle="mol N eq"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue('impacts.eutrophicationTerrestrial', val === '' ? null : val)
          }}
          formikName="impacts.eutrophicationTerrestrial"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.eutrophicationTerrestrial === 0
              ? '0'
              : formik.values.impacts.eutrophicationTerrestrial
          }
        />
        <InputItem
          name="Freshwater ecotoxicity"
          description="Unit of Measure: kg 1,4-DCB"
          type="input"
          addonTitle="kg 1,4-DCB"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue('impacts.freshwaterEcotoxicity', val === '' ? null : val)
          }}
          formikName="impacts.freshwaterEcotoxicity"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.freshwaterEcotoxicity === 0
              ? '0'
              : formik.values.impacts.freshwaterEcotoxicity
          }
        />
        <InputItem
          name="Freshwater eutrophication"
          description="Unit of Measure: kg P eq"
          type="input"
          addonTitle="kg P eq"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue('impacts.freshwaterEutrophication', val === '' ? null : val)
          }}
          formikName="impacts.freshwaterEutrophication"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.freshwaterEutrophication === 0
              ? '0'
              : formik.values.impacts.freshwaterEutrophication
          }
        />
        <InputItem
          name="Human carcinogenic toxicity"
          description="Unit of Measure: kg 1,4-DCB"
          type="input"
          addonTitle="kg 1,4-DCB"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue('impacts.humanCarcinogenicToxicity', val === '' ? null : val)
          }}
          formikName="impacts.humanCarcinogenicToxicity"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.humanCarcinogenicToxicity === 0
              ? '0'
              : formik.values.impacts.humanCarcinogenicToxicity
          }
        />
        <InputItem
          name="Human non-carcinogenic toxicity"
          description="Unit of Measure: kg 1,4-DCB"
          type="input"
          addonTitle="kg 1,4-DCB"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue('impacts.humanNonCarcinogenicToxicity', val === '' ? null : val)
          }}
          formikName="impacts.humanNonCarcinogenicToxicity"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.humanNonCarcinogenicToxicity === 0
              ? '0'
              : formik.values.impacts.humanNonCarcinogenicToxicity
          }
        />
        <InputItem
          name="Human toxicity cancer"
          description="Unit of Measure: CTUh"
          type="input"
          addonTitle="CTUh"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue('impacts.humanToxicityCancer', val === '' ? null : val)
          }}
          formikName="impacts.humanToxicityCancer"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.humanToxicityCancer === 0
              ? '0'
              : formik.values.impacts.humanToxicityCancer
          }
        />
        <InputItem
          name="Human toxicity non-cancer"
          description="Unit of Measure: CTUh"
          type="input"
          addonTitle="CTUh"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue('impacts.humanToxicityNonCancer', val === '' ? null : val)
          }}
          formikName="impacts.humanToxicityNonCancer"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.humanToxicityNonCancer === 0
              ? '0'
              : formik.values.impacts.humanToxicityNonCancer
          }
        />
        <InputItem
          name="Ionising radiation (human health)"
          description="Unit of Measure: kBq U235 eq"
          type="input"
          addonTitle="kBq U235 eq"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue('impacts.ionisingRadiation', val === '' ? null : val)
          }}
          formikName="impacts.ionisingRadiation"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.ionisingRadiation === 0
              ? '0'
              : formik.values.impacts.ionisingRadiation
          }
        />
        <InputItem
          name="Marine ecotoxicity"
          description="Unit of Measure: kg 1,4-DCB"
          type="input"
          addonTitle="kg 1,4-DCB"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue('impacts.marineEcotoxicity', val === '' ? null : val)
          }}
          formikName="impacts.marineEcotoxicity"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.marineEcotoxicity === 0
              ? '0'
              : formik.values.impacts.marineEcotoxicity
          }
        />
        <InputItem
          name="Marine eutrophication"
          description="Unit of Measure: kg N eq"
          type="input"
          addonTitle="kg N eq"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue('impacts.marineEutrophication', val === '' ? null : val)
          }}
          formikName="impacts.marineEutrophication"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.marineEutrophication === 0
              ? '0'
              : formik.values.impacts.marineEutrophication
          }
        />
        <InputItem
          name="Particulate matter"
          description="Unit of Measure: disease incidence"
          type="input"
          addonTitle="disease incidence"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue('impacts.particulateMatter', val === '' ? null : val)
          }}
          formikName="impacts.particulateMatter"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.particulateMatter === 0
              ? '0'
              : formik.values.impacts.particulateMatter
          }
        />
        <InputItem
          name="Photochemical ozone formation (human health)"
          description="Unit of Measure: kg NMVOC eq"
          type="input"
          addonTitle="kg NMVOC eq"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue('impacts.photochemicalOzoneFormation', val === '' ? null : val)
          }}
          formikName="impacts.photochemicalOzoneFormation"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.photochemicalOzoneFormation === 0
              ? '0'
              : formik.values.impacts.photochemicalOzoneFormation
          }
        />
        <InputItem
          name="Stratospheric ozone depletion"
          description="Unit of Measure: kg CFC11 eq"
          type="input"
          addonTitle="kg CFC11 eq"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue('impacts.stratosphericOzoneDepletion', val === '' ? null : val)
          }}
          formikName="impacts.stratosphericOzoneDepletion"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.stratosphericOzoneDepletion === 0
              ? '0'
              : formik.values.impacts.stratosphericOzoneDepletion
          }
        />
        <InputItem
          name="Terrestrial ecotoxicity"
          description="Unit of Measure: kg 1,4-DCB"
          type="input"
          addonTitle="kg 1,4-DCB"
          onChange={e => {
            const val = (e.target as HTMLInputElement).value
            formik.setFieldValue('impacts.terrestrialEcotoxicity', val === '' ? null : val)
          }}
          formikName="impacts.terrestrialEcotoxicity"
          formik={formik}
          showAsterisk={false}
          defaultValue={
            formik.values.impacts.terrestrialEcotoxicity === 0
              ? '0'
              : formik.values.impacts.terrestrialEcotoxicity
          }
        />
      </div>
    </div>
  )
}

export default Impacts
